<app-table-scrollable
  [table]="headerTable"
  [filterNotRequired]="true"
  [hideEmptyState]="true"
  (headerToggled)="changeInHeader($event)">
</app-table-scrollable>

<div class="boxed-border width-100 padding-15 request-form">
  <div class="row">
    <div class="col-md-4 ui-fluid">
      <mat-label>From</mat-label><br />
      <p-calendar
        [(ngModel)]="fromDate"
        icon="pi pi-calendar"
        [showIcon]="true"
        (ngModelChange)="onFromDateChange()"
        [minDate]="minFromDate"
        [maxDate]="maxFromDate">
      </p-calendar>
    </div>

    <div class="col-md-4 ui-fluid">
      <mat-label>To</mat-label><br />
      <p-calendar
        [(ngModel)]="toDate"
        icon="pi pi-calendar"
        [showIcon]="true"
        (ngModelChange)="onToDateChange()"
        [minDate]="minToDate"
        [maxDate]="maxToDate">
      </p-calendar>
    </div>

    <div class="col-md-4">
      <mat-label>Email (optional)</mat-label><br />
      <input
        [(ngModel)]="email"
        (ngModelChange)="onEmailChange()"
        class="form-control"
        type="text"
        placeholder="customer@email.com" />
    </div>
  </div>

  <div class="row margin-top-10" *ngIf="validationError">
    <div class="col color-red">
      {{validationError}}
    </div>
  </div>

  <div class="row margin-top-10">
    <div class="col">
      <button class="btn btn-primary" [disabled]="!!validationError || submitting" (click)="submit()">
        {{ submitting ? 'Submitting…' : 'Request invoice/receipt' }}
      </button>
      <span class="hint margin-left-10">
        Max {{constraints.maxLookbackDays}} days lookback, max {{constraints.maxRangeDays}} days per request.
      </span>
    </div>
  </div>
</div>


